window.dbs = window.dbs || {}
dbs.utilities = dbs.utilities || {}

dbs.utilities.document = (function () {
  function disableScroll() {
    const body = document.body
    const scrollY = window.scrollY
    body.style.position = 'fixed'
    body.style.top = `-${scrollY}px` // retain page scroll position
  }

  function enabledScroll() {
    const body = document.body
    const scrollY = body.style.top
    body.style.position = ''
    body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1) // retain page scroll position
  }

  return {
    disableScroll,
    enabledScroll,
  }
})()

/**
 * ------------------------------------------------------------------------
 * Private TransitionEnd Helpers
 * ------------------------------------------------------------------------
 */

const MILLISECONDS_MULTIPLIER = 1000

dbs.utilities.getTransitionDurationFromElement = function (element) {
  if (!element) {
    return 0
  }

  console.log('element', element)

  // Get transition-duration of the element
  let transitionDuration = $(element).css('transition-duration')
  let transitionDelay = $(element).css('transition-delay')

  const floatTransitionDuration = parseFloat(transitionDuration)
  const floatTransitionDelay = parseFloat(transitionDelay)

  // Return 0 if element or transition duration is not found
  if (!floatTransitionDuration && !floatTransitionDelay) {
    return 0
  }

  // If multiple durations are defined, take the first
  transitionDuration = transitionDuration.split(',')[0]
  transitionDelay = transitionDelay.split(',')[0]

  return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER
}

/**
 * ------------------------------------------------------------------------
 * Debounce
 * ------------------------------------------------------------------------
 */

// See: https://davidwalsh.name/javascript-debounce-function

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
dbs.utilities.debounce = function (func, wait, immediate) {
  let timeout
  return function () {
    let context = this,
      args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

// Function to get the item (and check if it's expired)
dbs.utilities.getLocalStorageWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);

  // Return null if item doesn't exist
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // Compare current time with expiry time
  if (now.getTime() > item.expiry) {
    // Item has expired, remove it
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

// Function to set localStorage with expiration
dbs.utilities.setLocalStorageWithExpiry = (key, value, expiryDays) => {
  const now = new Date();

  // Create item with value and expiry time
  const item = {
    value: value,
    expiry: now.getTime() + (expiryDays * 24 * 60 * 60 * 1000) // Convert days to milliseconds
  };

  // Save to localStorage as string
  localStorage.setItem(key, JSON.stringify(item));
}
